/**
 * @flow
 */

/* eslint-disable */

'use strict';


/*::
import type { ConcreteRequest } from 'relay-runtime';
export type aggregatesListingMapQueryVariables = {|
  slug: string
|};
export type aggregatesListingMapQueryResponse = {|
  +aggregatesListingBySlug: ?{|
    +mapData: ?{|
      +point: ?{|
        +lat: number,
        +lng: number,
      |},
      +area: ?{|
        +bbox: ?$ReadOnlyArray<?number>,
        +coordinates: $ReadOnlyArray<$ReadOnlyArray<$ReadOnlyArray<[number, number]>>>,
      |},
    |}
  |}
|};
export type aggregatesListingMapQuery = {|
  variables: aggregatesListingMapQueryVariables,
  response: aggregatesListingMapQueryResponse,
|};
*/


/*
query aggregatesListingMapQuery(
  $slug: String!
) {
  aggregatesListingBySlug(slug: $slug) {
    mapData {
      point {
        lat
        lng
      }
      area(lowRes: false) {
        bbox
        coordinates
      }
    }
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "slug"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "slug"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "AggregatesListingMapData",
  "kind": "LinkedField",
  "name": "mapData",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Coordinates",
      "kind": "LinkedField",
      "name": "point",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lat",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lng",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "lowRes",
          "value": false
        }
      ],
      "concreteType": "GeoJSONMultiPolygon",
      "kind": "LinkedField",
      "name": "area",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "bbox",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "coordinates",
          "storageKey": null
        }
      ],
      "storageKey": "area(lowRes:false)"
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "aggregatesListingMapQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AggregatesListing",
        "kind": "LinkedField",
        "name": "aggregatesListingBySlug",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "aggregatesListingMapQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AggregatesListing",
        "kind": "LinkedField",
        "name": "aggregatesListingBySlug",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "d3503bbf7bb49612ea65052a6223ce8e",
    "id": null,
    "metadata": {},
    "name": "aggregatesListingMapQuery",
    "operationKind": "query",
    "text": "query aggregatesListingMapQuery(\n  $slug: String!\n) {\n  aggregatesListingBySlug(slug: $slug) {\n    mapData {\n      point {\n        lat\n        lng\n      }\n      area(lowRes: false) {\n        bbox\n        coordinates\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '5ad9f8baf4b6771b94023bb46241babc';

export default node;
